import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';


import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import * as uri from '../../config/uri';
import RaisedButton from 'material-ui/RaisedButton';
import { HeaderDiv } from '../../modals';
import { invalidateUser } from '../../reducers/userReducer';
import { ACCENT_COLOR } from '../../config/colors'
import { pushWithQueryParams } from '../../services/uri';

const styles = {
  closeIcon: { "position":"absolute",top:0,"right":"0","margin":"8px 5px 0 0" },
  labelStyle: {fontWeight:700}
};

class SignupCancelledModal extends Component {
    modalStyle = { border: '3px solid ' + ACCENT_COLOR };
    handleCloseClick = () => {
      // invalidate
      this.props.hideModal();
      this.props.go(uri.rootPageUri);
      this.props.invalidate();
    }

  render() {
    // const color = this.props.error ? 'd41c1c' : this.props.secondaryColor ;
    return (
      <Modal
        style={this.modalStyle}
        overlayTop={0}
        paddingTop={100}
        closeOnOutsideClick={true}
        isOpened={true}
        onClose={this.onCloseRequest}>
        <ModalWrapperDiv>
            <HeaderDiv color={`#616161`}>Your account has been cancelled</HeaderDiv>
              <ButtonsWrapperDiv>
                 <RaisedButton
                    onClick={this.handleCloseClick}
                    backgroundColor={`#` + this.props.secondaryColor}
                    labelColor="#FFF"
                    label="OK"
                    labelStyle={styles.labelStyle}
                  />
              </ButtonsWrapperDiv>
        </ModalWrapperDiv>
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      hideModal: () => dispatch(modal.hideModal()),
      openSignUpForm: () => dispatch(modal.openModal({
        modalType: 'SIGNUP_FORM',
        modalProps: {}
      })),
      go: (path) => dispatch(pushWithQueryParams(path)),
      invalidate: () => dispatch(invalidateUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupCancelledModal);

const ModalWrapperDiv = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: 100%;
    font-family: 'Futura-Bold',  sans-serif;
`;


const ButtonsWrapperDiv = styled.div `
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
`;




// WEBPACK FOOTER //
// ./src/components/SignupCancelledModal/SignupCancelledModal.jsx